import React from 'react'

import ProductListCardBase, { ProductListCardBaseProps } from 'components/_new/product/ProductListCardBase/ProductListCardBase'
import { DeliveryStatus, DeliveryStatusProps } from 'components/_new/ui'


type DeliveryProductListCardListCard = Omit<ProductListCardBaseProps, 'rightNode' | 'bottomNode'> & {
  deliveryDate: DeliveryStatusProps['deliveryDate']
  deliveryState?: DeliveryStatusProps['state']
}

const DeliveryProductListCard: React.FunctionComponent<DeliveryProductListCardListCard> = (props) => {
  const { image, brand, name, label, deliveryDate, deliveryState } = props

  return (
    <ProductListCardBase
      image={image}
      brand={brand}
      name={name}
      label={label}
      bottomNode={(
        <DeliveryStatus
          deliveryDate={deliveryDate}
          state={deliveryState}
          color="brand"
          uppercase={false}
        />
      )}
    />
  )
}


export default React.memo(DeliveryProductListCard)
